export type GenericData = { [key: string]: unknown };

export enum StatusKey {
  Total = 'total',
  High = 'high',
  VeryHigh = 'very_high',
  Medium = 'medium',
  Low = 'low',
  Completed = 'COMPLETED',
}
export const EMPTY_KEY = 'EMPTY';

export const getStatusCount = <T extends GenericData>(
  statusKey: keyof T | StatusKey,
  data: T[],
  statusKeyList?: StatusKey[],
  shouldCountEmpty = false,
) => {
  if (statusKey.toString().toLocaleLowerCase() === StatusKey.Total) {
    return { total: data.length };
  }

  const initialStatus = statusKeyList
    ? statusKeyList.reduce((acc, key) => ({ ...acc, [key]: 0 }), {})
    : {};

  const result = data.reduce((counts, item) => {
    const currentStatus = item[statusKey as string] as string;
    if (currentStatus) {
      counts[currentStatus] = (counts[currentStatus] || 0) + 1;
    }
    if (shouldCountEmpty && !currentStatus) {
      counts[EMPTY_KEY] = (counts[EMPTY_KEY] || 0) + 1;
    }

    return counts;
  }, initialStatus as { [key: string]: number });

  if (statusKeyList?.includes(StatusKey.Total)) {
    result[StatusKey.Total] = data.length;
  }

  return result;
};
